import type { ScheduleDropdownProps } from './types'

import { Checkbox } from 'antd'
import { useMemo } from 'react'

import { generateWeek } from '../functions'

export function ScheduleDropdown({ value, onChange }: ScheduleDropdownProps): JSX.Element {
  const days = useMemo(() => generateWeek(), [])
  const weeks = useMemo(() => Array.from({ length: 5 }, (_, i) => i + 1), [])

  return (
    <div className='bg-white p-4 border rounded-md grid grid-cols-[10rem,_1fr] gap-1'>
      {days.map(day => {
        if (!day) {
          return null
        }

        const k = day.slice(0, 3).toUpperCase()
        const v = value?.[k] ?? []

        return (
          <div key={day} className='contents'>
            <Checkbox
              checked={v.length === weeks.length}
              indeterminate={v.length > 0 && v.length < weeks.length}
              onChange={event => {
                onChange({
                  ...value,
                  [k]: event.target.checked ? [...weeks] : undefined
                })
              }}
            >
              {day}
            </Checkbox>

            <Checkbox.Group
              options={weeks.map(week => ({ label: week, value: week }))}
              value={v}
              onChange={weeks => {
                onChange({
                  ...value,
                  [k]: weeks.length > 0 ? (weeks as number[]) : undefined
                })
              }}
            />
          </div>
        )
      })}
    </div>
  )
}
